const moneda = 'Bs.';

export default moneda;
